var App = App || {};

App.Quiz = (function ($) {
	"use strict";

	var $quiz = $('.quiz__viewport'),
		$panels = $quiz.find('.course__panels'),
		$progress = $quiz.find('.course__progress'),
		$currentStep = $quiz.find('.course__steps--current'),
		$totalSteps = $quiz.find('.course__steps--total'),
		$feedback = $quiz.find('.course__feedback'),
		_totalSteps = $panels.find('.course__panel').length,
		_courseKey,
		_baseUrl;

	function init(courseKey) {
		_courseKey = courseKey;

		const navigationEntries = performance.getEntriesByType('navigation');
		if (navigationEntries.length && navigationEntries[0].type === 'back_forward') {
			window.location.reload();
			return;
		}

		App.waitForImagesToLoad('.course__panels')
			.then(setMinHeight);

		$totalSteps.html(_totalSteps);
		App.$window.on('enter-sm enter-md enter-lg enter-xl', setMinHeight);

		$panels.slick({
			arrows: false,
			autoplay: false,
			accessibility: false,
			dots: false,
			draggable: false,
			infinite: false,
			swipe: false,
			adaptiveHeight: true,
			slidesToScroll: 1
		});

		$panels.find('.course__panel').each(function () {
			var $this = $(this),
				$radios = $this.find('[type="radio"]'),
				$submit = $this.find('.btn.disabled');

			$radios.on('change', function (e) {
				$submit.removeClass('disabled');
			});
		});

		$panels.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var bp = ZAGFramework.GetCurrentBP();

			$currentStep.html(nextSlide + 1);
			$progress.stop().animate({ 'width': (100 * ((nextSlide + 1) / _totalSteps)) + '%' });

			if (bp === 'sm' || bp === 'md') {
				scrollToTop();
			}
		});

		getUserCourse(_courseKey).done(function (response, textStatus, jqXHR) {
			if (!response) {
				console.log("API did not respond.");
				return;
			}

			if (response.success) {
				if (!response.data || (response.data.Status == "Complete")) {
					window.location.href = "/learn/courses";
					return;
				}

				_baseUrl = response.data.baseUrl;

				$panels.slick("slickGoTo", response.data.questionIndex, false);
				return
			}

			$panels.slick("slickGoTo", 0, false);

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error("Request failed:", textStatus, errorThrown);
		});

		$panels.slick("slickGoTo", 0, true);
	}

	function getUserCourse(key) {
		return $.ajax({
			cache: false,
			url: `/api/courses/${key}`,
			type: "GET",
			dataType: "json"
		});
	}

	function scrollToTop() {
		$('html,body').animate({ scrollTop: $quiz.offset().top }, 500);
	}

	function setMinHeight() {
		var minHeight = 0,
			bp = ZAGFramework.GetCurrentBP();

		if (["lg", "xl", "xxl"].includes(bp)) {
			$panels.find('.course__panel').each(function () {
				var h = $(this).height();
				minHeight = minHeight > h ? minHeight : h;
			});
		}

		$panels.find('.course__panel').css('min-height', minHeight);
	}

	function submitAnswer(questionKey, isComplete) {
		var answerKey = $(`input[name=${questionKey}]:checked`).val();

		var params = {
			questionKey = questionKey,
			answerKey = answerKey
		};

		$.ajax({
			cache: false,
			url: `/api/courses/${_courseKey}/apply_answer/`,
			data: JSON.stringify(params),
			type: "PUT",
			dataType: "json",
			contentType: 'application/json; charset=utf-8'
		}).done(function (response, textStatus, jqXHR) {
			if (!response || !response.success) {
				showFeedback(false, "An unxpected error occured. Unable to score quiz. If this issue persists, please contact support.", false);
				return;
			}

			if (response.success) {
				showFeedback(response.data.isCorrect, response.data.explanation, isComplete);
				return;
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			showFeedback(false, "An unxpected error occured. Unable to score quiz. If this issue persists, please contact support.", false);
		});
	}

	function showFeedback(correct, explanation, isComplete) {
		var cls = 'course__feedback--' + (correct ? 'correct' : 'incorrect');
		$feedback.addClass(cls);
		$feedback.find('.response').html('<div class="h1">' + (correct ? '<i class="fa fa-check-circle"></i> Correct!' : '<i class="fa fa-times-circle"></i> Incorrect') + '</div><p>' + explanation + '</p>');
		if (isComplete) {
			$feedback.find('#ShowReport').removeClass('d-none');
			$feedback.find('#NextQuestion').addClass('d-none');
		}
		$feedback.removeClass('d-none');
	}

	function moveNext() {
		$feedback.removeClass('course__feedback--correct course__feedback--incorrect').addClass('d-none');
		$feedback.find('.response').empty();
		$panels.slick("slickNext");
	}

	function finalize() {
		window.location.href = _baseUrl;
	}

	return {
		init: init,
		moveNext: moveNext,
		submitAnswer: submitAnswer,
		finalize: finalize
	};
})(jQuery);